import React from 'react';
import 'leaflet/dist/leaflet.css';
import MarkersWrapper, { ShapeType } from '../Shapes/MarkersWrapper';

export interface SimpleMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    shape: ShapeType;
    showTooltip: boolean;
    onClick?: (event: any) => void;
}
const SimpleMarker = (props: SimpleMarkerProps) => {
    return (
        <MarkersWrapper
            onClick={props.onClick}
            key={props.key}
            opacity={0.8}
            isAnimated={false}
            shape={props.shape}
            showTooltip={props.showTooltip}
            color={props.color}
            position={props.position}
            radius={props.radius}
            name={props.name}
            fteDVMs={props.fteDVMs}></MarkersWrapper>
    );
};

export default SimpleMarker;
